var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoystick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 242.1 299.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M242.1 165l-40.86-30.82-.84-.64-32.85-24.78v18.64l26.52 20L217.3 165l-96.25 72.6L24.8 165l30.28-23 19.18-14.47v-18.58L0 165l.16.1-.16.1V208l121.05 91.3L242.1 208v-42.8l-.15-.13zm-14.87 35.6l-106.18 80.03-106.18-80.1V176.2l106.18 80.08 106.18-80.08v24.37z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.12 100.4v54.3a31.77 31.77 0 0 0 63.53 0v-54.06a55.32 55.32 0 1 0-63.53-.24zm48.66 54.3a16.9 16.9 0 0 1-33.8 0v-46.8a55 55 0 0 0 33.8.12v46.67zM121.05 14.87A40.44 40.44 0 1 1 80.6 55.32a40.5 40.5 0 0 1 40.45-40.44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.05 38.42a16.9 16.9 0 0 1 16.88 16.9 7.44 7.44 0 1 0 14.87 0A31.8 31.8 0 0 0 121 23.54a7.44 7.44 0 1 0 .05 14.87z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoystick);
export default __webpack_public_path__ + "static/media/joystick.412d201edf8505b8b61a228ed89cb698.svg";
export { ForwardRef as ReactComponent };